import React from "react";

const CheckIcon = () => (
  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
);

// step: 0-based index of current active step
const StepProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center w-full">
      {steps.map((label, i) => {
        const isCompleted = i < currentStep;
        const isActive = i === currentStep;

        return (
          <React.Fragment key={i}>
            <div className="flex flex-col items-center">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-colors ${
                  isCompleted
                    ? "bg-brand border-brand text-white"
                    : isActive
                    ? "bg-brand border-brand text-white"
                    : "bg-white border-cardBorder text-textMuted"
                }`}
              >
                {isCompleted ? <CheckIcon /> : <span>{i + 1}</span>}
              </div>
              <span
                className={`mt-1.5 text-xs font-medium whitespace-nowrap ${
                  isActive ? "text-brand" : isCompleted ? "text-brand" : "text-textMuted"
                }`}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-2 mb-5 transition-colors ${
                  i < currentStep ? "bg-brand" : "bg-cardBorder"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepProgressBar;
